<kc-icon-button
  class="theme-toggle"
  role="switch"
  [attr.aria-checked]="themeService.theme() === 'light'"
  [icon]="icon()"
  size="sm"
  variant="secondary"
  [ariaLabel]="label()"
  [title]="label()"
  (buttonClick)="themeService.toggle()"
/>
